import type { UpdateViewDto } from "../generated/schema";
import useInvalidateShop from "./use-invalidate-shop";
import { useApiMutation } from "./use-api-mutation";

export default function useUpdateShopView(shopId: string, viewId: string) {
  const invalidateShop = useInvalidateShop(shopId);

  return useApiMutation("patch", "/shops/{shopId}/views/{viewId}", {
    invalidate: invalidateShop,
    mapVariables: (body: UpdateViewDto) => ({
      params: { path: { shopId, viewId } },
      body: body,
    }),
  });
}
